<span class="relative inline-flex items-end justify-end">
  <button
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    type="button"
    class="inline-flex items-center justify-center rounded-full text-blue-600 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:text-blue-400 dark:hover:text-blue-300 dark:focus-visible:ring-offset-gray-900"
    [attr.aria-label]="label() ? 'Ulteriori informazioni per ' + label() : 'Ulteriori informazioni'"
    [attr.aria-describedby]="isOpen() ? id() : null"
    [attr.aria-expanded]="isOpen()"
    (mouseenter)="show()"
    (mouseleave)="scheduleHide()"
    (focus)="show()"
    (blur)="scheduleHide()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      class="h-4 w-4 cursor-help outline-none"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.06-1.06 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clip-rule="evenodd"
      />
    </svg>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (positionChange)="onPositionChange($event)"
  >
    <span
      [id]="id()"
      role="tooltip"
      class="relative block border bg-white px-3 py-2 text-left text-xs font-normal text-gray-700 shadow-xl whitespace-normal wrap-break-word rounded-lg border-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 z-50 pointer-events-auto max-w-[80vw]"
      [style.width]="tooltipWidth()"
      (mouseenter)="show()"
      (mouseleave)="scheduleHide()"
    >
      <span class="block space-y-2">
        @for (block of hintBlocks(); track $index) {
          @if (block.kind === 'paragraph') {
            <span class="block leading-relaxed">
              @for (segment of block.segments; track $index) {
                @if (segment.kind === 'link') {
                  <a
                    [href]="segment.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="pointer-events-auto break-all text-blue-700 underline underline-offset-2 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-200"
                  >
                    {{ segment.text }}
                  </a>
                } @else {
                  {{ segment.text }}
                }
              }
            </span>
          } @else {
            <ul class="list-disc pl-4 space-y-1 leading-relaxed">
              @for (item of block.items; track $index) {
                <li>
                  @for (segment of item; track $index) {
                    @if (segment.kind === 'link') {
                      <a
                        [href]="segment.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="pointer-events-auto break-all text-blue-700 underline underline-offset-2 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-200"
                      >
                        {{ segment.text }}
                      </a>
                    } @else {
                      {{ segment.text }}
                    }
                  }
                </li>
              }
            </ul>
          }
        }
      </span>
      <!-- Arrow pointing down (default) -->
      @if (placement() === 'top') {
        <span
          class="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-gray-200 dark:border-t-gray-700"
        ></span>
        <span
          class="absolute left-1/2 -translate-x-1/2 top-full -mt-px w-0 h-0 border-x-[5px] border-x-transparent border-t-[5px] border-t-white dark:border-t-gray-800"
        ></span>
      }
      <!-- Arrow pointing up (when at top) -->
      @if (placement() === 'bottom') {
        <span
          class="absolute left-1/2 -translate-x-1/2 bottom-full w-0 h-0 border-x-[6px] border-x-transparent border-b-[6px] border-b-gray-200 dark:border-b-gray-700"
        ></span>
        <span
          class="absolute left-1/2 -translate-x-1/2 bottom-full -mb-px w-0 h-0 border-x-[5px] border-x-transparent border-b-[5px] border-b-white dark:border-b-gray-800"
        ></span>
      }
    </span>
  </ng-template>
</span>
